import { useEffect } from 'react';
import { usePushNotifications } from '../hooks/usePushNotifications';

/**
 * Component that checks push notification permissions on mount.
 * If the user has pushStatus=1 but hasn't granted browser permission,
 * it will automatically request permission.
 */
const PushNotificationPermissionChecker: React.FC = () => {
  const { checkAndRequestPermission } = usePushNotifications();
  
  useEffect(() => {
    // The hook already handles checking if user has pushStatus=1
    // and will request permission if needed
  }, []);
  
  return null;
};

export default PushNotificationPermissionChecker;